/**
 * Lab Backend-UI loads highstock + exporting + export-data (index.html).
 * Cached so modules compose once per page.
 */

import type Highcharts from 'highcharts'

type StockNs = typeof Highcharts

let cached: StockNs | null = null
let loading: Promise<StockNs> | null = null

/** Highcharts Stock + Winner7 context menu (fullscreen / print / image / CSV / XLS). */
export async function loadHighchartsStock(): Promise<StockNs> {
  if (cached) return cached
  if (loading) return loading

  loading = (async () => {
    const mod = await import('highcharts/esm/highstock.js')
    const Highcharts = mod.default as StockNs
    // Side-effect modules attach to the Highcharts singleton (Lab exporting.js).
    await import('highcharts/esm/modules/exporting.js')
    await import('highcharts/esm/modules/export-data.js')
    await import('highcharts/esm/modules/offline-exporting.js')
    cached = Highcharts
    return Highcharts
  })()

  try {
    return await loading
  } finally {
    loading = null
  }
}
